import React from 'react';
import { Box } from '@mui/material';
import { DialogUI } from '../Interface';
import { OtherActivityReportPage } from './OtherActivityReportPage';

const OtherActivityReportDialog = ({ dialogData, handleClose, setRefetch }) => {
  const { open, data } = dialogData;

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Egyéb tevékenység lejelentő"
      closeBtn
      maxWidth="xl"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            mx: 0.5,
          },
        },
        '& .MuiDialogContent-root': {
          px: 0,
        },
      }}
    >
      <OtherActivityReportPage
        dialog={{
          dialogData: data,
          setRefetch,
        }}
      />
    </DialogUI>
  );
};

export default OtherActivityReportDialog;
